export const dashboardJson = {
    "payload": {
        "shop": {
            "totalSalesValue": 43300000,
            "totalParcelsCount": 95,
            "totalPackageCount": 95,
            "totalShippingAmount": 23100011,
            "orderCountByDate": [
                {
                    "date": 1669149000,
                    "count": 9
                },
                {
                    "date": 1670358600,
                    "count": 18
                },
                {
                    "date": 1670617800,
                    "count": 1
                },
                {
                    "date": 1670790600,
                    "count": 67
                }
            ],
            "receivedOrderCountByDate": [],
            "orderCountByStatus": [
                {
                    "status": "ناموفق و مرجوعی",
                    "count": 4
                },
                {
                    "status": "درحال پردازش",
                    "count": 12
                },
                {
                    "status": "عدم جمع آوري از فرستنده",
                    "count": 5
                },
                {
                    "status": "ثبت اولیه",
                    "count": 74
                }
            ],
            "orderCountByProviders": {
                "اکوپیک": 38,
                "پادرو اکسپرس": 32,
                "ندکس": 4,
                "لینک اکسپرس": 13,
                "شرکت ملی پست (پیشتاز)": 5,
                "ماهکس": 2,
                "اسپید": 1
            },
            "orderCountByCity": {
                "رشت": 1,
                "شیراز": 2,
                "تهران": 45,
                "پردیس": 4,
                "اهواز": 5,
                "کرمانشاه": 1,
                "تبریز": 4,
                "قم": 1,
                "خرم آباد": 1,
                "کرج": 2,
                "مشهد": 6,
                "قرچک": 1,
                "بندرعباس": 2,
                "شهریار": 3,
                "زاهدان": 3,
                "بوشهر": 2,
                "ساری": 1,
                "ارومیه": 1,
                "سنندج": 2,
                "اراک": 1,
                "همدان": 1,
                "قزوین": 1,
                "بیرجند": 1,
                "اسلامشهر": 1,
                "اصفهان": 2,
                "گرگان": 1
            },
            "updatedOrders": {
                "75": {
                    "orderId": "epk010921ut2",
                    "receiverName": "مسعود محمدیان",
                    "receiverAddress": "قزوین.شهرک مینودر.میدان حافظ.پارک سنگی. خ سلمان.کوچه نهضت پلاک19 واحد2 پلاک 19 واحد 2",
                    "providerName": "اکوپیک",
                    "status": "ثبت اولیه"
                },
                "79": {
                    "orderId": "epk010921i74",
                    "receiverName": "میریوسف اساییان",
                    "receiverAddress": "مرند-خیابان شهیدرجایی کوچه اسلام آباد کوی لاله غربی پلاک 38 واحد 1",
                    "providerName": "اکوپیک",
                    "status": "ثبت اولیه"
                },
                "80": {
                    "orderId": "epk010921cdn",
                    "receiverName": "محسن عبدی",
                    "receiverAddress": "طبس-بلوار شهید رجایی بالاتر از مسجدالرسول بریدگی اول درب هخامنشی پلاک  واحد 1",
                    "providerName": "اکوپیک",
                    "status": "ثبت اولیه"
                },
                "85": {
                    "orderId": "epk010921xce",
                    "receiverName": "امین خوراسگانی",
                    "receiverAddress": "تست",
                    "providerName": "اکوپیک",
                    "status": "ثبت اولیه"
                },
                "89": {
                    "orderId": "epk010921tc2",
                    "receiverName": "سیدحسین صدر",
                    "receiverAddress": "گزبرخوار-بلوار شهدا کوی گل افشان  پلاک 27 واحد 1",
                    "providerName": "اکوپیک",
                    "status": "ثبت اولیه"
                }
            },
            "reports": [
                {
                    "link": "https://portal.podro.com/api/reports/e2780f8d-5ffe-11ed-9684-0242ac12000e.csv",
                    "status": "DONE",
                    "createdAt": 1667978383
                },
                {
                    "link": "https://portal.podro.com/api/reports/9b434cbc-5dd4-11ed-a6ad-0242ac1c0002.csv",
                    "status": "DONE",
                    "createdAt": 1667740323
                },
                {
                    "link": "https://portal.podro.com/api/reports/3ed0a9ba-82f3-4412-9a3c-2ece95e1618b.xlsx",
                    "status": "DONE",
                    "createdAt": 1665408864
                },
                {
                    "link": "https://portal.podro.com/api/reports/e79a8c60-922a-4cab-ab49-064a58285ae7.xlsx",
                    "status": "DONE",
                    "createdAt": 1658734491
                },
                {
                    "link": "https://portal.podro.com/api/reports/cf84ed55-d0db-44ec-9067-9de22f62708f.xlsx",
                    "status": "DONE",
                    "createdAt": 1658649129
                },
                {
                    "link": "https://portal.podro.com/api/reports/013acfe6-1863-4df1-9068-48bb55f1d359.xlsx",
                    "status": "DONE",
                    "createdAt": 1658648765
                },
                {
                    "link": "https://portal.podro.com/api/reports/e775b998-68ef-4a6e-afc5-91841f598123.xlsx",
                    "status": "DONE",
                    "createdAt": 1658573440
                },
                {
                    "link": "https://portal.podro.com/api/reports/a53cb20a-1a8b-4346-845b-5dd577eda8b5.xlsx",
                    "status": "DONE",
                    "createdAt": 1658318541
                },
                {
                    "link": "https://portal.podro.com/api/reports/94bc4c62-7c00-42c9-ae6a-bf22a6f75497.xlsx",
                    "status": "DONE",
                    "createdAt": 1658317749
                },
                {
                    "link": "https://portal.podro.com/api/reports/f43948e0-cbe8-4f18-aac5-30fd527e8cfc.xlsx",
                    "status": "DONE",
                    "createdAt": 1658317744
                },
                {
                    "link": "https://portal.podro.com/api/reports/e94555f4-5730-4191-9553-c6a85c92c004.xlsx",
                    "status": "DONE",
                    "createdAt": 1658305185
                },
                {
                    "link": "https://portal.podro.com/api/reports/52d37ff5-fcfd-43cb-87ad-301d9de922df.xlsx",
                    "status": "DONE",
                    "createdAt": 1658305174
                },
                {
                    "link": "https://portal.podro.com/api/reports/bfb1e713-e6ee-43ce-b892-067725c085af.xlsx",
                    "status": "DONE",
                    "createdAt": 1658305084
                },
                {
                    "link": "https://portal.podro.com/api/reports/c8f67b8e-2b2b-4082-adad-7bf8015e72f3.xlsx",
                    "status": "DONE",
                    "createdAt": 1658303444
                },
                {
                    "link": "https://portal.podro.com/api/reports/38ef79a3-3df3-457c-9496-1c02f0376c05.xlsx",
                    "status": "DONE",
                    "createdAt": 1657351209
                },
                {
                    "link": "https://portal.podro.com/api/reports/b5816ba7-2842-4eda-94e0-e5305798551e.xlsx",
                    "status": "DONE",
                    "createdAt": 1657019649
                }
            ]
        }
    },
    "message": "عملیات با موفقیت انجام شد"
}